import { BrowserRouter, Route, Routes } from "react-router-dom";
import Subscribe from "./pages/subscribe";
import Unsubscribe from "./pages/unsubscribe";
import JoinForm from "./pages/join-form";
import JoinFormUnderAge  from "./pages/join-form-underage";
import SuccessKvkkPage from "./pages/join-form/successPage";
import SuccessKvkkPageUnderAge from "./pages/join-form-underage/successPage"
import Layout from "./pages/layout/Layout";
import MemberApplicationForm from "./pages/member-application-form";
import AvisForm from "./pages/avis-form";
import RelativeJoinForm from "./pages/relative-join-form";
import FamilyMemberJoinForm from "./pages/family-member-join-form";
import CongratPage from "./pages/congrats/CongratPage";
import CongratParents from "./pages/congrats/CongratParents";
import CongratSpouse from "./pages/congrats/CongratSpouse";
import CongratChild from "./pages/congrats/CongratChild";
import WhatsappUnsubscribe from "./pages/whatsapp-unsubscribe";
import UnderagePermitForm from "./pages/underage-permit-form";
import YkbConsentForm from "./pages/ykb-consent-form";
import RelativeJoinDocument from "./pages/relative-join-document";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const App = () => {

  const theme = createTheme({
    typography: {
      fontFamily: '"Roboto", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/subscribe" element={<Layout><Subscribe /></Layout>} />
          <Route path="/unsubscribe" element={<Layout><Unsubscribe /></Layout>} />
          <Route path="/join-form/:comApprovePrivateNo?" element={<Layout><JoinForm /></Layout>} />
          <Route path="/join-form/success" element={<SuccessKvkkPage />} />
          <Route path="/join-form-underage/:comApprovePrivateNo?" element={<Layout><JoinFormUnderAge /></Layout>} />
          <Route path="/join-form-underage/success" element={<SuccessKvkkPageUnderAge />} />
          <Route path="/relative-join-form" element={<RelativeJoinForm />} />
          <Route path="/relative-join-document" element={<RelativeJoinDocument />} />
          <Route path="/family-member-join-form" element={<FamilyMemberJoinForm />} />
          <Route path="/member-application-form" element={<MemberApplicationForm />} />
          <Route path="/join-form/congrats" element={<CongratPage />} />
          <Route path="/join-form/congrats-parents" element={<CongratParents />} />
          <Route path="/join-form/congrats-spouse" element={<CongratSpouse />} />
          <Route path="/join-form/congrats-child" element={<CongratChild />} />
          <Route path="/whatsapp-izin-yonetimi" element={<WhatsappUnsubscribe />} />
          <Route path="/15-18-yas-uyelik-izni/:guid?" element={<UnderagePermitForm />} />
          <Route path="/ykb-veri-aktarim-onay/:encriptedText?" element={<YkbConsentForm />} />
          <Route path="/avis-form" element={<AvisForm />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
